import('./pb-cardscarousel.css');
const slick = require("slick-carousel");
const slickCSS = require("slick-carousel/slick/slick.css");

const pbCardsCarousel = {
    init: function () {
        let carousels = [];
        let carIdx = 0;
        
        $('.pb-cardscarousel').find('.pb-carousel').each(function() {
            let self = $(this);
            let par = self.parents('.pb-cardscarousel');
            
            carousels[carIdx] = $(this).slick({
                slidesToShow: 5,
           //     loop: false,
                slidesToScroll: 2,
                infinite: false,
                dots: true,
                arrows: true,
                variableWidth: true,
                prevArrow: par.find('.slick-prev'),
                nextArrow: par.find('.slick-next'),
                responsive: [
                    {
                        breakpoint: 1442,
                        settings: {
                          variableWidth: true,
                          slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                          variableWidth: true,
                          slidesToShow: 3
                        }
                      },
                    {
                      breakpoint: 1024,
                      settings: {
                        variableWidth: true,
                        slidesToShow: 1
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        variableWidth: true,
                        slidesToShow: 1                        
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1
                      }
                    }
                ]
            }); 
/*

            carousels[carIdx].on('afterChange', function (event, slick, currentSlide) {
    
                var total = self.find('.pb-carousel .pb-item--container').length;
                if(currentSlide === (total-1)) {
                    $('.slick-next').addClass('hidden');
                }
                else {
                    $('.slick-next').removeClass('hidden');
                }
        
                if(currentSlide === 0) {
                    $('.slick-prev').addClass('hidden');
                }
                else {
                    $('.slick-prev').removeClass('hidden');
                }  
            });
*/            

            $(this).find('.jsArrows').on('click', function(e) {
                if($(this).hasClass('slick-disabled')) {
                    $(this).hide();
                } else {
                    $(this).show();
                }

                return false;
            });

            $(this).data('idx', carIdx);
/*
            $('.pb-carousel--prev.slick-prev').on('click', function(e){
                e.preventDefault();

                let idx = self.data('idx');
                carousels[idx].slick('slickPrev');

                return false;
            });

            $('.pb-carousel--next.slick-next').on('click',function(e) {
                e.preventDefault();

                let idx = self.data('idx');
                carousels[idx].slick('slickNext');
                
                return false;
            });
*/
            carIdx++;
        });

        $('.pb-cardscarousel').find('.pb-carousel--controller-container').find('a').on('click',function(ev){
            ev.preventDefault();            

            const target = $(this).attr("href");
            const id = target.replace("#", "");

            if($('.pb-cardscarousel').find(`#${id} .slick-slide`).length == 1){
                $('.pb-carousel--controller').fadeOut('fast');
            } else {
                $('.pb-carousel--controller').fadeIn('fast');
            }

            if(target) {
                $(this).closest('ul').find('a').each(function(){
                    $(this).removeClass('selected');
                });

                $(this).addClass('selected');

                $(this).closest('.pb-cardscarousel').find('.pb-carousel').each(function(){
                    $(this).removeClass('show');
                });

                $(this).closest('.pb-cardscarousel').find(target).addClass('show');

                
                let idx = $('.pb-cardscarousel .pb-carousel.show').data('idx');
                carousels[idx].slick('slickGoTo', 0);
            }
            return false;

        });

        $('.pb-cardscarousel').find('.pb-carousel-container').find('.pb-item a').on('click',function(ev)
        {
            ev.preventDefault();
            return false;
        });
        
    }

}

window.loadedComponents.push({ component: 'pb-cardscarousel', init: pbCardsCarousel.init});

export default() => {
    pbCardsCarousel.init();
}